import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Account, Event, Participant, Team, UserRoles} from "../../domain/models";
import {OpenbandService} from "../../services/openband/openband.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NotificationService} from "../../services/notifications/notification.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Title} from "@angular/platform-browser";
import {PreferencesService} from "../../services/preferences/preferences.service";
import {ToastrService} from "ngx-toastr";
import {Sort} from "../participants/participants.component";
import {FilterListPipe} from "../../helpers/pipes/filter-list-by-bib.pipe";
import {interval} from "rxjs";
import {FilterTeamsByBibPipe} from "../../helpers/pipes/filter-teams-by-bib.pipe";

@Component({
  selector: 'app-mass-assignment',
  templateUrl: './mass-assignment.component.html',
  styleUrls: ['./mass-assignment.component.scss']
})
export class MassAssignmentComponent implements OnInit {

  private subscription

  massAssignmentForm: FormGroup;
  participants: Participant[] = [];
  teams: Team[] = [];
  filteredParticipants: Participant[] = [];
  filteredTeams: Team[] = [];
  selectedParticipants: Participant[] = [];
  selectedTeams: Team[] = [];
  filteredParticipantsForMassAssign: Participant[] = [];
  searchQuery: string = '';
  isFullScreen: boolean = false;
  eventId: string = "";
  currentEvent: Event;
  account: Account = new Account();
  events: string[] = [];
  categories: string[] = [];
  isLoading: boolean = false;
  currentSort = new Sort();
  participantToEdit: Participant = new Participant();
  pipe = new FilterListPipe();
  teamsPipe = new FilterTeamsByBibPipe();
  bibAssignForm: FormGroup;
  bibsQuery: string = "";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private notifyService: NotificationService,
    private modalService: NgbModal,
    private titleService: Title,
    private prefs: PreferencesService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private participantService: OpenbandService
  ) {
    this.massAssignmentForm = this.fb.group({
      numbers: ['', Validators.required]
    });
    titleService.setTitle(`Массовое присвоение номеров`);
    route?.queryParams?.subscribe(params => {
      var old = prefs.appPreferences
      var newToken = params['token']
      if (newToken?.length > 3) {
        old.token = newToken
        prefs.setAppPreferences(old)
      } else {
      }
    })
    route.params.subscribe(params => {
        this.parseRouteParams(params.id.toString())
        this.loadParticipants()
        this.loadEvent()
        this.loadAccount()
      }
    )
    this.initBibAssignForm();
  }

  initBibAssignForm() {
    this.bibAssignForm = this.fb.group({
      bibNumbers: [''],
      searchQuery: [''],
      selectedTeams: [[]]
    });

    // Подписываемся на изменения в поле поиска
    this.bibAssignForm.get('searchQuery').valueChanges.subscribe(query => {
      this.filterTeams();
    });
  }

  loadAccount() {
    this.participantService.getAccountSettings().subscribe(
      res => this.account = res
    )
  }

  loadEvent() {
    this.participantService.getEvent(this.eventId).subscribe(
      res => {
        this.currentEvent = res
        this.titleService.setTitle(res.name);
        this.currentEvent.eventConfig?.distances?.forEach(d => {
          if (!this.events.includes(d.name)) {
            this.events.push(d.name);
          }
          d.categories.forEach(c => {
            if (!this.categories.includes(c.name)) {
              this.categories.push(c.name);
            }
          });
        })
        this.categories.sort();
      }
    )
  }

  parseRouteParams(params: string) {
    var splitted = params.split(";")
    this.eventId = splitted[0];
  }

  ngOnInit(): void {
    this.subscription = interval(60_000).subscribe((val) => {
      this.loadParticipants()
    })
  }

  loadParticipants(): void {
    this.isLoading = true;
    this.participantService.getParticipants(this.eventId).subscribe(
      (participants: Participant[]) => {
        this.participants = participants;
        this.groupParticipants()
        this.filterTeams();
        this.isLoading = false;
      },
      (error) => {
        console.error('Error loading participants:', error);
        this.notifyService.showError('Ошибка при загрузке участников');
        this.isLoading = false;
      }
    );
  }

  // Метод группировки:
  private groupParticipants(): void {
    this.teams.forEach(t => {
      t.participants = []
    })
    this.participants.forEach((participant: Participant) => {
      var index = this.teams.findIndex((value) => value.name == participant.club)
      if (index != -1) {
        this.teams[index].participants.push(participant)
        this.teams[index]?.updateBibStatus();
      } else {
        var teamToCreate = new Team()
        teamToCreate.name = participant.club
        teamToCreate.participants = []
        teamToCreate.participants.push(participant)
        this.teams[index]?.updateBibStatus();
        this.teams.push(teamToCreate)
      }
    })
    this.teams.sort((a, b) => {
      if (a.areBibsAssigned && !b.areBibsAssigned) {
        return 1; // Команда A должна быть ниже, так как номера уже присвоены
      } else if (!a.areBibsAssigned && b.areBibsAssigned) {
        return -1; // Команда B должна быть ниже, так как номера уже присвоены
      } else {
        return 0; // Остальные команды остаются в текущем порядке
      }
    });
  }

  filterParticipants(): void {
    if (this.searchQuery == "") {
      this.filteredParticipants = this.participants;
      return;
    }

    const query = this.searchQuery.toLowerCase();
    this.filteredParticipants = this.participants.filter(participant => {
      return (
        participant.surname.toLowerCase()?.includes(query) ||
        participant.name.toLowerCase()?.includes(query) ||
        participant.phone?.includes(query) ||
        participant.club?.includes(query) ||
        participant.event?.toString()?.includes(query)
      );
    });
  }

  filterTeams(): void {
    if (this.searchQuery == "") {
      this.filteredTeams = this.teams;
      return;
    }

    const query = this.searchQuery.toLowerCase();
    this.filteredTeams = this.teams.filter(participant => {
      return (
        participant.name?.toLowerCase()?.includes(query)
      );
    });
  }

  toggleParticipantSelection(participant: Participant): void {
    const index = this.selectedParticipants.findIndex(p => p.id === participant.id);
    if (index === -1) {
      this.selectedParticipants.push(participant);
    } else {
      this.selectedParticipants.splice(index, 1);
    }
  }

  toggleTeamSelection(team: Team): void {
    const index = this.selectedTeams.findIndex(p => p.name === team.name);
    if (index === -1) {
      this.selectedTeams.push(team);
    } else {
      this.selectedTeams.splice(index, 1);
    }
  }

  toggleAllParticipants(event: any): void {
    if (event.target.checked) {
      this.selectedParticipants = [...this.pipe.transform(this.participants, this.searchQuery)];
    } else {
      this.selectedParticipants = [];
    }
  }

  toggleAllTeams(event: any): void {
    if (event.target.checked) {
      this.selectedTeams = [...this.teamsPipe.transform(this.teams, this.searchQuery)];
    } else {
      this.selectedTeams = [];
    }
  }

  toggleUnselected(): void {
    (document.getElementById("cb-select") as HTMLInputElement).checked = false
    this.selectedParticipants = [];
  }

  toggleTeamsUnselected(): void {
    (document.getElementById("cb-select") as HTMLInputElement).checked = false
    this.selectedTeams = [];
  }

  isParticipantSelected(participant: Participant): boolean {
    return this.selectedParticipants.some(p => p.id === participant.id);
  }

  isTeamSelected(team: Team): boolean {
    return this.selectedTeams.some(p => p.name === team.name);
  }

  countTotalParticipants(): number {
    return this.selectedTeams.reduce((total, team) => total + team.participants.length, 0);
  }

  checkDuplicates(numbers: number[]): number[] {
    return numbers.filter(num => this.participants.some(p => p.bib === num.toString()));
  }

  onSubmit(): void {
    if (this.selectedParticipants.length > 0) {
      const numbers = this.parseNumbers(this.bibsQuery);

      var filtered = this.pipe.transform(this.participants, this.searchQuery)
      if (numbers.length !== this.selectedParticipants.length) {
        this.notifyService.showError('Количество номеров не соответствует количеству выбранных участников');
        return;
      }

      if (numbers.length === 0) {
        this.toastr.error('Неверный формат номеров');
        return;
      }

      if (filtered.length === 0) {
        this.toastr.error('Выберите хотя бы одного участника');
        return;
      }

      //TODO make checkup on backend

      // const duplicates = this.checkDuplicates(numbers);
      // if (duplicates.length > 0) {
      //   this.toastr.warning(`Следующие номера уже используются: ${duplicates.join(', ')}`);
      //   return;
      // }

      this.isLoading = true;
      this.selectedParticipants.forEach((participant, index) => {
        participant.bib = numbers[index].toString();
      });

      Promise.all(this.selectedParticipants.map(participant =>
        this.participantService.updateParticipant(this.currentEvent.id, participant).toPromise()
      )).then(() => {
        this.notifyService.showSuccess('Номера успешно присвоены');
        this.bibsQuery = ""
        this.toggleUnselected();
        this.loadParticipants();
        this.selectedParticipants = [];
        this.massAssignmentForm.reset();
      }).catch(error => {
        console.error('Error assigning numbers:', error);
        this.notifyService.showError('Ошибка при присвоении номеров');
      }).finally(() => {
        this.isLoading = false;
      });
    }
  }

  onSubmitTeams(): void {
    if (this.selectedTeams.length > 0) {
      const numbers = this.parseNumbers(this.bibsQuery);

      var filtered = this.selectedTeams.map(x => x.participants).flat()

      if (numbers.length !== filtered.length) {
        this.notifyService.showError('Количество номеров не соответствует количеству выбранных участников');
        return;
      }

      if (numbers.length === 0) {
        this.toastr.error('Неверный формат номеров');
        return;
      }

      if (filtered.length === 0) {
        this.toastr.error('Выберите хотя бы одного участника');
        return;
      }

      //TODO make checkup on backend

      // const duplicates = this.checkDuplicates(numbers);
      // if (duplicates.length > 0) {
      //   this.toastr.warning(`Следующие номера уже используются: ${duplicates.join(', ')}`);
      //   return;
      // }

      this.isLoading = true;
      filtered.forEach((participant, index) => {
        participant.bib = numbers[index].toString();
      });

      Promise.all(filtered.map(participant =>
        this.participantService.updateParticipant(this.currentEvent.id, participant).toPromise()
      )).then(() => {
        this.notifyService.showSuccess('Номера успешно присвоены');
        this.bibsQuery = ""
        this.toggleTeamsUnselected();
        this.loadParticipants();
        this.searchQuery = ""
        this.selectedTeams = [];
        this.massAssignmentForm.reset();
      }).catch(error => {
        console.error('Error assigning numbers:', error);
        this.notifyService.showError('Ошибка при присвоении номеров');
      }).finally(() => {
        this.isLoading = false;
      });
    }
  }

  private parseNumbers(input: string): number[] {
    const numbers: number[] = [];
    var splitter = ","
    if (input.includes(",") == false) splitter = " "
    const parts = input.split(splitter).map(p => p.trim());

    for (const part of parts) {
      if (part.includes('-')) {
        const [start, end] = part.split('-').map(n => parseInt(n.trim()));
        if (!isNaN(start) && !isNaN(end) && start <= end) {
          for (let i = start; i <= end; i++) {
            if (i >= 1 && i <= 9999) {
              numbers.push(i);
            }
          }
        }
      } else {
        const num = parseInt(part);
        if (!isNaN(num) && num >= 1 && num <= 9999) {
          numbers.push(num);
        }
      }
    }

    return numbers;
  }

  toggleFullScreen(): void {
    if (!this.isFullScreen) {
      this.openFullScreen();
    } else {
      this.closeFullScreen();
    }
  }

  private openFullScreen(): void {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
      this.isFullScreen = true;
    } else if ((element as any).webkitRequestFullscreen) {
      (element as any).webkitRequestFullscreen();
      this.isFullScreen = true;
    } else if ((element as any).msRequestFullscreen) {
      (element as any).msRequestFullscreen();
      this.isFullScreen = true;
    }
  }

  private closeFullScreen(): void {
    if (document.exitFullscreen) {
      document.exitFullscreen();
      this.isFullScreen = false;
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
      this.isFullScreen = false;
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
      this.isFullScreen = false;
    }
  }

  formatForInputDate(inputDate) {
    try {
      return inputDate.split("/").reverse().join("-");
    } catch (e) {
      return ""
    }
  }

  openEditParticipantDialog(content: any, participant: Participant) {
    this.participantToEdit = new Participant();
    this.participantToEdit.id = participant.id
    this.participantToEdit.eventId = participant.eventId
    this.participantToEdit.bib = participant.bib
    this.participantToEdit.tag = participant.tag
    this.participantToEdit.name = participant.name
    this.participantToEdit.surname = participant.surname
    this.participantToEdit.club = participant.club
    this.participantToEdit.phone = participant.phone
    this.participantToEdit.dateOfBirth = this.formatForInputDate(participant.dateOfBirth)
    this.participantToEdit.gender = participant.gender
    this.participantToEdit.category = participant.category
    this.participantToEdit.event = participant.event
    this.participantToEdit.uin = participant.uin
    this.participantToEdit.externalId = participant.externalId
    this.participantToEdit.isFromOtherEvent = participant?.isFromOtherEvent
    this.participantToEdit.eventName = participant?.eventName
    this.participantToEdit.eventShortName = participant.eventShortName
    this.modalService.open(content,
      {
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
      }).result.then(
      (result) => {
        if (this.participantToEdit?.isFromOtherEvent || this.canEdited() == false) {
          this.notifyService.showError("Редактирование участника запрещено")
          return
        }
        if (this.participantToEdit?.bib == null) this.participantToEdit.bib = ""
        try {
          this.participantToEdit.dateOfBirth = this.format(this.participantToEdit.dateOfBirth)
        } catch (e) {
          console.log(e)
        }
        this.participantService.updateParticipant(this.eventId, this.participantToEdit).subscribe(
          result => {
            this.notifyService.showSuccess("Обновлено")
            this.loadParticipants()
          },
          error => {
          }
        )
        //TODO add updating participant
        // this.api.updatePunch(participant).subscribe(
        //   res => {
        //   },
        //   error => this.notifyService.showError(error.error.message)
        // )
        this.participantToEdit = new Participant()
      },
      (reason) => {
        this.participantToEdit = new Participant()
      });
  }

  format(inputDate) {
    try {
      return inputDate.split("-").reverse().join("/");
    } catch (e) {
      return ""
    }
  }

  canEdited() {
    if (this.account.role == UserRoles.super_admin || this.account.role == UserRoles.admin) return true
    if (this.participantToEdit?.isFromOtherEvent) return false
    let found = this.findDistance()
    if (found != null) {
      let diff = Date.parse(found?.offlineRegistrationEndsAt) - Date.now()
      return diff >= 0;
    } else {
      return true
    }
  }

  findDistance() {
    return this.currentEvent?.eventConfig?.distances?.find(x => x?.name == this?.participantToEdit?.event)
  }

  openBibAssignDialog(content) {
    this.filteredParticipantsForMassAssign = [...this.participants];
    this.selectedParticipants = [];
    this.bibAssignForm.reset();
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });
  }

  onBibKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === 'Done') { // Проверяем, была ли нажата клавиша Enter
      event.preventDefault(); // Предотвращаем стандартное поведение
      this.hideKeyboard();   // Вызываем метод для скрытия клавиатуры
    }
  }

  hideKeyboard(): void {
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement && activeElement.blur) {
      activeElement.blur(); // Убираем фокус с текущего элемента
    }
  }
}
